import React, { useState } from "react";
import { cx } from "@jugl-web/utils";
import overview from "./assets/overview.mp4";
import preview from "./assets/preview.jpg";

export const OverviewVideo: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative h-full w-full overflow-hidden">
      <img
        src={preview}
        alt=""
        className={cx(
          "h-full w-full object-cover",
          loaded ? "opacity-0" : "opacity-100"
        )}
      />

      <video
        src={overview}
        muted
        autoPlay
        loop
        playsInline
        preload="auto"
        onLoadedData={() => setLoaded(true)}
        className={cx(
          "absolute top-0 left-0 h-full w-full object-cover",
          loaded ? "opacity-100" : "opacity-0"
        )}
      />
    </div>
  );
};
